class LoginDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#LoginDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderLoginIconAccessibility();
    this.checkAndHandleLoginState();

  }

  checkAndHandleLoginState() {
  
    const isLoggedIn = document.body.classList.contains('customer-logged-in');
    if (isLoggedIn) {
      this.close();
    }
  }

  setHeaderLoginIconAccessibility() {

    const loginLink = document.querySelector("#login-icon-bubble");
    if (!loginLink) return;

    loginLink.setAttribute("role", "button");
    loginLink.setAttribute("aria-haspopup", "dialog");
    loginLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(loginLink);
    });
    loginLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(loginLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const loginDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (loginDrawerNote && !loginDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(loginDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    const hikoContainer = this.querySelector('[name="hiko-container"]');
    const registerBlock = this.querySelector('.login-drawer-register');
    if (hikoContainer && registerBlock) {
        hikoContainer.parentNode.insertBefore(registerBlock, hikoContainer.nextSibling);
    }

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("LoginDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(loginDrawerNote) {
    loginDrawerNote.setAttribute("role", "button");
    loginDrawerNote.setAttribute("aria-expanded", "false");

    if (loginDrawerNote.nextElementSibling.getAttribute("id")) {
      loginDrawerNote.setAttribute(
        "aria-controls",
        loginDrawerNote.nextElementSibling.id
      );
    }

    loginDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    loginDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#LoginDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "login-drawer",
        selector: "#LoginDrawer",
      },
      {
        id: "login-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("login-drawer", LoginDrawer);
